// third-party
import { FormattedMessage } from "react-intl";

// assets
import {
  IconChartTreemap,
  IconTemplate,
  IconFileAnalytics,
} from "@tabler/icons-react";

// type
import { NavItemType } from "shared/types";
import { ERoles } from "shared/types/roles";

const icons = {
  IconChartTreemap: IconChartTreemap,
  IconTemplate: IconTemplate,
  IconFileAnalytics: IconFileAnalytics,
};


const templates: NavItemType = {
  id: "tools",
  title: <FormattedMessage id='tools' />,
  icon: icons.IconChartTreemap,
  type: "group",
  roles: [ERoles.director],
  children: [
    {
      id: "template-parameters",
      title: <FormattedMessage id='template-parameters' />,
      type: "item",
      icon: icons.IconTemplate,
      url: "/tools/template-parameters",
      breadcrumbs: true,
      chip: { color: "primary" },
    },
    {
      id: "analytical-report",
      title: <FormattedMessage id='analytical-report' />,
      type: "item",
      icon: icons.IconFileAnalytics,
      url: "/tools/analytical-report",
      breadcrumbs: true,
      chip: { color: "primary" },
    },
    // {
    //   id: "analytics-treemap",
    //   title: <FormattedMessage id='analytics-treemap' />,
    //   type: "item",
    //   icon: icons.IconChartTreemap,
    //   url: "/tools/analytics-treemap",
    //   breadcrumbs: true,
    //   chip: { color: "primary" },
    // },
  ],
};

export default templates;
